import styled from 'styled-components';
import colors from '../../styles/colors';

export const BarProgress = styled.div`
  background-color: #d8d8d8;
  border-radius: 20px;
  position: relative;
  margin: 15px 0;
  height: 30px;
  width: 450px;
`;

export const BarProgressDone = styled.div`
  background: linear-gradient(to left, ${colors.aux1_light}, ${colors.aux1});
  box-shadow: 0 3px 3px -5px ${colors.aux1}, 0 2px 5px ${colors.aux1};
  border-radius: 20px;
  border: 1px solid ${colors.aux1};
  color: #000;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 3%;
  left: 0.1%;
  height: 100%;
  width: 0;
  opacity: 0;
  /* transition: 0.25s ease 0.05s; */
  z-index: 49;
`;

export const ProgressCount = styled.h4`
  position: absolute;
  left: 46%;
  font-weight: bold;
  z-index: 99;
  margin-top: 5px;
`;
